export default "__VITE_ASSET__9af17159__"